<template>
  <div>
    <div
      v-if="dObject"
      :class="$vuetify.breakpoint.smAndDown ? 'ml-0 mr-0' : 'ml-15 mr-15'"
    >
      <h1 style="text-align:center">{{ companyName }}</h1>
      <h2 style="text-align:center">{{ chargeTitle }}</h2>
      <v-container v-if="!chargeSuccess">
        <v-row>
          <v-col cols="12">
            <v-form-card
              :dObject="dObject"
              ref="form"
              :panels="true"
              :key="formKey"
              mHeight="75vh"
            ></v-form-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn
              v-if="model.agree_terms"
              class="text-center"
              :loading="loading"
              color="primary"
              @click="chargeCard()"
            >
              Authorize Payment
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-alert
        class="ml-n2"
        dismissible
        dense
        timeout="3000"
        v-if="errorMessage"
        type="error"
      >
        {{ errorMessage }}
      </v-alert>
      <v-alert
        class="ml-n2"
        dismissible
        dense
        timeout="3000"
        v-if="successMessage"
        type="success"
      >
        {{ successMessage }}
      </v-alert>
      <!-- </v-card-actions> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "CreditCard",
  components: {
    VFormCard: () => import("../components/FormCard.vue"),
  },
  props: {
    portal_id: [String, Number],
  },
  data() {
    return {
      data: null,
      model: {},
      dObject: null,
      terms: `<div style='text-align:left'>
        <h2 style='text-align:center'>TERMS AND CONDITIONS</h2>

        <p>By submitting your credit card information to complete a purchase on our website, you acknowledge and agree to the following terms and conditions:</p>

        <ul>
          <li><strong>Payment Authorization:</strong> You authorize us to charge your credit card for the total amount of the purchase, including any applicable taxes and fees.</li>
          <li><strong>Payment Processing:</strong> We will process your payment as soon as possible. However, we reserve the right to refuse or cancel any transaction for any reason at any time.</li>
          <li><strong>Payment Disputes:</strong> If you have any disputes or questions about your payment, please contact us immediately. We will make every effort to resolve the issue promptly and fairly.</li>
          <li><strong>Refunds and Returns:</strong> All sales are final. We do not offer refunds or returns unless there is a defect in the product or an error in the transaction.</li>
          <li><strong>Security:</strong> We take the security of your personal and financial information seriously. We use industry-standard encryption and security measures to protect your information.</li>
          <li><strong>Privacy:</strong> We respect your privacy and will only use your personal and financial information to process your transaction and comply with applicable laws and regulations.</li>
          <li><strong>Governing Law:</strong> These terms and conditions are governed by the laws of [insert governing jurisdiction]. Any disputes arising from or related to these terms and conditions will be resolved in the courts of [insert governing jurisdiction].</li>
        </ul>

        <p>By submitting your credit card information, you acknowledge that you have read, understood, and agree to these terms and conditions. If you do not agree to these terms and conditions, please do not complete the transaction.</p>
        </div>`,
      encriptedData: null,
      decryptedData: null,
      companyName: "",
      shipment: null,
      chargeTitle: "Please pay your balance with the credit card",
      successMessage: "",
      errorMessage: "",
      chargeSuccess: false,
      loading: false,
    };
  },
  mounted() {
    // this.terms = document.getElementById("terms").innerHTML;
    this.encriptedData = this.$route.params.encrypted;
    axios
      .post(
        this.serverURL + "/decrypt",
        { encrypted: this.encriptedData },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        this.decryptedData = response.data;
        this.refreshData();
      });
  },
  beforeDestroy() {},
  methods: {
    chargeCard() {
      this.errorMessage = "";
      var form = this.$refs["form"].$refs["form"].$refs["form"];
      if (!form.validate()) {
        return;
      }
      if (!this.model.address) {
        this.errorMessage = "Address is invalid";
        return;
      }
      var address = this.model.address.geo.location.address;

      var chargeData = {
        portal_id: this.decryptedData.portal_id,
        company_id: this.decryptedData.company_id,
        payment: {
          card_number: this.model.card_number,
          card_expire: this.model.card_expire,
          cvv2: this.model.cvv2,
          amount: this.model.amount,
        },
        customer: {
          first_name: this.model.first_name,
          last_name: this.model.last_name,
          address: address.house + " " + address.street,
          apt: "",
          city: address.city,
          state: address.stateCode,
          zip: address.postalCode,
          country: address.country,
          invoice_number: this.decryptedData.shipment_id,
        },
      };
      this.loading = true;
      axios
        .post(this.serverURL + "/charge_card", chargeData)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            if (response.data.result_code.toLowerCase() != "error") {
              this.addPaymentToShipment();
              this.successMessage =
                "Thank you for your payment. Card has been charged code: " +
                response.data.result_code;
              this.chargeSuccess = true;
            } else {
              this.errorMessage = response.data.message;
            }
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },
    addPaymentToShipment() {
      var paymentDate = fun.formatDate(new Date(), true, true);
      var paymentData = {
        portal_id: this.decryptedData.portal_id,
        shipment_id: this.decryptedData.shipment_id,
        payment_data: {
          payment: {
            payment_date: paymentDate,
            amount: this.model.amount,
            payment_type: "credit_card",
            card_number: this.model.card_number,
            card_expire: this.model.card_expire,
            cvv2: this.model.cvv2,
          },
        },
      };
      axios
        .post(this.serverURL + "/add_payment", paymentData)
        .then((response) => {
          if (response.data == "success") {
            console.log("success");
          }
        });
    },
    refreshData() {
      var that = this;

      this.data = { object_name: "credit_card" };
      this.data.portal_id = this.decryptedData.portal_id;

      this.data.additional_data = [
        {
          obj_name: "company",
          qry: {
            _id: this.decryptedData.company_id,
          },
        },
        {
          obj_name: "v_shipment_letter_fields",
          // fields: ["customer", "payments", "total_estimate"],
          qry: {
            shipment_id: this.decryptedData.shipment_id,
          },
        },
      ];
      axios
        .post(this.serverURL + "/get_data", this.data, {
          withCredentials: true,
        })
        .then((response) => {
          that.dObject = { schema: {} };
          that.dObject.schema = response.data.schema;
          that.dObject.schema.properties.agree_terms.panel_content = that.terms;
          that.dObject.objectName = "credit_card";

          this.dObject.additionalModel = this.additionalModel;
          that.dObject.model = that.model;
          that.companyName =
            response.data.additional_model.company[0].company_name;
          that.shipment =
            response.data.additional_model.v_shipment_letter_fields[0];
          that.model.amount = that.decryptedData.amount;
          that.dObject.schema.properties.amount["v-bind"].readonly = true;
          that.model.first_name = that.shipment.customer.contact.first_name;
          that.model.last_name = that.shipment.customer.contact.last_name;

          // that.model.address = that.shipment.customer.address[0].full_address;
        })
        .catch((reason) => {
          // console.log(reason);
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
